import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { SessionStore } from '../stores'
import { getTenant } from './get-tenant'
import Router from 'next/router'

export function withTenant (TenantComponent) {
  @inject('sessionStore')
  @observer
  class Tenant extends Component {
    constructor (props) {
      super(props)
      this.state = {
        ready: false
      }
    }

    componentDidMount () {
      const tenant = getTenant()
      if (tenant === 'systemadmin') {
        this.props.sessionStore.setSysAdmin(tenant)

        if (!this.props.sessionStore.isAdminLoggedIn) {
          this.setState({ ready: true })
        }

        // this.setState({ ready: true })
      } else if (!this.props.sessionStore.hasTenant) {
        this.props.sessionStore.tenantExists(tenant)
          .then((res) => {
            if (!res.data.exists) {
              return Router.push('/register')
            }
            this.props.sessionStore.setTenant(tenant)
            this.setState({ ready: true })
          })
          .catch((err) => {
            console.log('Error while checking tenant :', err)
            this.props.sessionStore.setLastError(err)
            Router.push('/error')
          })
      } else {
        this.setState({ ready: true })
      }
    }

    render () {
      if (this.state.ready) {
        return <TenantComponent {...this.props} />
      } else {
        return <div>&nbsp;</div>
      }
    }
  }

  Tenant.propTypes = {
    sessionStore: PropTypes.instanceOf(SessionStore)
  }

  return Tenant
}
